import React from 'react';
import { partners } from '../mock';
import { Shield, Award, CheckCircle2, Star } from 'lucide-react';

const Partners = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Background decorativo */}
      <div className="absolute inset-0 opacity-10 overflow-hidden pointer-events-none">
        <div className="absolute top-10 left-10 w-72 h-72 bg-cyan-500 rounded-full filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl animate-pulse delay-1000"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Header da seção */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center gap-2 mb-4 px-4 py-2 bg-cyan-500/10 border border-cyan-500/30 rounded-full">
            <Shield className="w-5 h-5 text-cyan-400" />
            <span className="text-cyan-400 font-semibold text-sm uppercase tracking-wider">Parceiros Oficiais</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4 bg-gradient-to-r from-white via-cyan-200 to-blue-200 bg-clip-text text-transparent">
            Assistência Técnica Autorizada - Revenda e Suporte Técnico Autorizado
          </h2>
          <p className="text-xl text-blue-300 max-w-2xl mx-auto">
            Trabalhamos com as melhores marcas do mercado para garantir soluções de qualidade e confiança
          </p>
        </div>

        {/* Badge de destaque */}
        <div className="flex flex-wrap items-center justify-center gap-6 mb-12">
          <div className="flex items-center gap-2 px-4 py-2 bg-slate-800/50 border border-cyan-500/30 rounded-lg">
            <Award className="w-5 h-5 text-cyan-400" />
            <span className="text-white font-medium">Certificados Oficiais</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-slate-800/50 border border-cyan-500/30 rounded-lg">
            <CheckCircle2 className="w-5 h-5 text-cyan-400" />
            <span className="text-white font-medium">Suporte Autorizado</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-slate-800/50 border border-cyan-500/30 rounded-lg">
            <Star className="w-5 h-5 text-cyan-400" />
            <span className="text-white font-medium">Qualidade Garantida</span>
          </div>
        </div>
        
        {/* Grid de parceiros */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 max-w-5xl mx-auto">
          {partners.map((partner, index) => (
            <div
              key={partner.id}
              className="group relative bg-white/95 backdrop-blur-sm rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl hover:shadow-cyan-500/20 transition-all duration-500 hover:-translate-y-3 border-2 border-transparent hover:border-cyan-500/50"
              style={{
                animationDelay: `${index * 100}ms`,
                animation: 'fadeInUp 0.6s ease-out forwards'
              }}
            >
              {/* Badge de parceiro autorizado */}
              <div className="absolute -top-3 -right-3 bg-gradient-to-br from-cyan-500 to-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center gap-1">
                <Shield className="w-3 h-3" />
                Oficial
              </div>

              {/* Logo do parceiro */}
              <div className="flex items-center justify-center h-20 md:h-24 mb-3 grayscale group-hover:grayscale-0 transition-all duration-500">
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-w-full max-h-full object-contain transform group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              {/* Nome do parceiro */}
              <div className="text-center">
                <h3 className="text-slate-800 font-bold text-sm md:text-base group-hover:text-cyan-600 transition-colors duration-300">
                  {partner.name}
                </h3>
                <p className="text-xs text-slate-500 mt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Parceiro Autorizado
                </p>
              </div>

              {/* Borda animada no hover */}
              <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
                <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-cyan-500/20 to-blue-500/20 blur-xl"></div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to action */}
        <div className="text-center mt-16">
          <p className="text-slate-300 text-lg mb-4">
            Soluções certificadas e suporte especializado para sua empresa
          </p>
          <div className="inline-flex items-center gap-2 text-cyan-400 font-semibold">
            <CheckCircle2 className="w-5 h-5" />
            <span>Atendimento com qualidade assegurada</span>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default Partners;